import React from "react";
import { Target, Clock, AlertCircle, CheckCircle2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export const DashboardStats = ({ tasks }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-testid="dashboard-stats">
    <Card className="border-0 shadow-lg bg-gradient-to-br from-blue-50 to-blue-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-blue-900">Total Tasks</CardTitle>
        <Target className="h-4 w-4 text-blue-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-blue-900">{tasks.length}</div></CardContent>
    </Card>
    <Card className="border-0 shadow-lg bg-gradient-to-br from-yellow-50 to-yellow-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-yellow-900">In Progress</CardTitle>
        <Clock className="h-4 w-4 text-yellow-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-yellow-900">{tasks.filter(t => t.status === 'in_progress').length}</div></CardContent>
    </Card>
    <Card className="border-0 shadow-lg bg-gradient-to-br from-red-50 to-red-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-red-900">Delayed</CardTitle>
        <AlertCircle className="h-4 w-4 text-red-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-red-900">{tasks.filter(t => t.status === 'delayed').length}</div></CardContent>
    </Card>
    <Card className="border-0 shadow-lg bg-gradient-to-br from-emerald-50 to-emerald-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-emerald-900">Completed</CardTitle>
        <CheckCircle2 className="h-4 w-4 text-emerald-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-emerald-900">{tasks.filter(t => t.status === 'completed').length}</div></CardContent>
    </Card>
  </div>
);
